import React from 'react';
import { Icon } from '@ontruck/orc';

const LateralLoad = ({ cellData }) => {
  return cellData ? <Icon size="4rem" glyph="extras-sideload" color="grey500" /> : null;
};

export default LateralLoad;
